:host {
  --anchor-bar-max-width: 1920px;

  @include media-max('xxl', false) {
    --anchor-bar-max-width: 1440px;
  }
}

.dc-ui-anchor-bar {
  background-color: $color-white;
  position: relative;
  transition: top 0.3s ease-in-out;
  display: flex;

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background-color: $color-grey-03;
    z-index: 1;
    isolation: isolate;
  }

  &--is-sticky {
    position: fixed;
    top: var(--header-offset-height, 0);
    left: 0;
    right: 0;
    z-index: 1000;
    max-width: var(--anchor-bar-max-width);
    margin: 0 auto;
    box-shadow: 0px 16px 32px -16px rgba(0, 43, 73, 0.32);

    &:before {
      bottom: unset;
      top: 0;
      background-color: $color-grey-01;
    }
  }

  &__inner {
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    margin: 0 auto;
    max-width: 1170px;
    height: 48px;
    width: 100%;

    &--has-overflow {
      padding-inline: 15px;
      grid-template-columns: auto 1fr auto;
      gap: 12px;
    }
  }

  &__inner-wrapper {
    display: flex;
    gap: 12px;
    max-width: 100%;
    // margin: 0 auto;
    overflow-x: auto;
    // Hide scrollbar for Chrome/Safari
    &::-webkit-scrollbar {
      display: none;
    }
    // Hide scrollbar for Firefox
    scrollbar-width: none;
  }
}
